import OpenURLBase from "./openurl.base";

export default class OpenURLWeb extends OpenURLBase {
  
  constructor() {
    super();
  }

  public override async open(url:string): Promise<boolean> {
    return window.open(url, '_blank') !== null;
  }
}